import { z } from "zod";
import { AvailabilityRestrictionTypes } from "../types/AvailabilityRestrictionType";

const ValueSchema = z.object({
    type: z.enum(AvailabilityRestrictionTypes.map((s) => s.value) as [string, ...string[]]),
    rate: z.coerce.number().optional(),
    availability: z.coerce.number().optional(),
    date_from: z.string(),
    date_to: z.string(),
    rate_plan_id: z.string(),
});

const UpdateAvailabilityRestrictionSchema = z.object({
    value: z.array(ValueSchema),
});

export { UpdateAvailabilityRestrictionSchema, ValueSchema };
export type UpdateAvailabilityRestrictionResponse = z.infer<typeof UpdateAvailabilityRestrictionSchema>;
export type ValueResponse = z.infer<typeof ValueSchema>;